import React, { useState } from "react";
import SelectInput from "./SelectInput"; // Assuming you have SelectInput as a separate component

interface TimePickerProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const TimePicker: React.FC<TimePickerProps> = ({ label, name, value, onChange, required = false }) => {
  const [hours, setHours] = useState<string>("0");
  const [minutes, setMinutes] = useState<string>("0");

  const handleHoursChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setHours(e.target.value);
    onChange(`${e.target.value}:${minutes}`);
  };

  const handleMinutesChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMinutes(e.target.value);
    onChange(`${hours}:${e.target.value}`);
  };

  // Creating hour and minute options dynamically
  const hourOptions = Array.from({ length: 24 }, (_, i) => ({
    value: i.toString(),
    label: `${i} ${i === 1 ? "hour" : "hours"}`,
  }));

  const minuteOptions = Array.from({ length: 60 }, (_, i) => ({
    value: i.toString(),
    label: `${i} ${i === 1 ? "minute" : "minutes"}`,
  }));

  return (
    <div className="flex flex-col sm:flex-row items-center gap-4">
      {/* <label className="block text-sm font-medium mb-1 sm:mb-0 mr-2">{label}</label> */}
      <div className="flex gap-2">
        {/* Hour Dropdown using SelectInput */}
        <SelectInput
          label={label+ "Hours"}
          name={`${name}-hours`}
          value={hours}
          onChange={handleHoursChange}
          options={hourOptions}
          required={required}
        />

        {/* Minute Dropdown using SelectInput */}
        <SelectInput
          label={label +" Minutes"}
          name={`${name}-minutes`}
          value={minutes}
          onChange={handleMinutesChange}
          options={minuteOptions}
          required={required}
        />
      </div>
    </div>
  );
};

export default TimePicker;
